import { useEffect } from "react";
import { useState } from "react";
import Select from "react-select";
import { Watch } from 'react-loader-spinner'
import { palette } from "../../../assets/theme/theme";
import { Autocomplete, TextField } from "@mui/material";



export default function MultipleSelect({ options, onChange, value, getter, formData, defaultOptions }: any) {



    const [entityList, setEntityList] = useState(defaultOptions? defaultOptions : []);

    const [loading, setLoading] = useState(false);

    const [triggerValue, setTriggerValue] = useState(formData[options.triggerParam])
    
    const [mounted, setMounted] = useState(false);


    useEffect(()=>{
        if(defaultOptions) setEntityList(defaultOptions)
    },[defaultOptions])


    const getValuesByGetter = async () => {
        setLoading(true);
        const data = await getter();
        setEntityList(data);
        setLoading(false);
    }



    const hasRegularGetter = (): boolean => {
        return getter && !options.triggerParam;
    }

    const hasInitialTriggerValue = (): boolean => {
        return getter && options.triggerParam && formData[options.triggerParam]
    }


    useEffect(() => {
        if (hasRegularGetter() || hasInitialTriggerValue()) {
            getValuesByGetter();
        }
        setMounted(true);

    }, [])


    useEffect(() => {
        if (mounted && getter && options.triggerParam) {
            getValuesByGetter();
            onChange([]);
        }
    }, [formData[options.triggerParam]])


    const getOptionLabel = (option: any) => {
  
        if(options.label.split('.').length > 1 && options.label.split('.').length < 3){
            return option[options.label.split('.')[0]][options.label.split('.')[1]];
        } else if(options.label.split('.').length == 1){
            return option[options.label];
        } else {
            return "Não suporto + que 2 níveis de nest"
        }
    }


    return (<>
        {!loading ? <div className="z-10" style={{ width: '100%' }}>
                <div>
                    <Autocomplete
                        multiple
                        id="tags-outlined"
                        className="z-10"
                        options={[...entityList]}
                        getOptionLabel={getOptionLabel}
                        filterSelectedOptions
                        onChange={(_, newValue) => { onChange(newValue); }}
                        value={value}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={options.name}
                                placeholder={options.name}
                            />
                        )}
                    />
                </div>
                
        </div>
            : <Watch
                height="55"
                width="55"
                color={palette.rodrimaq_red}
                ariaLabel='loading'
            />}
    </>)


}